import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { accessToken } from "./localData";
import { generalSlice, setIsLoggedIn } from "../redux/slices/generalSlice";

// Extract the non-hidden steps from the status object and find the next one after the last successful step.
export const getRejectedStep = (status) => {
  let steps = Object.entries(status)
    .map(([key, value]) => ({
      key,
      ...value,
    }))
    .filter((item) => !item.hidden);

  let lastSuccessFulStep = steps
    .map((item) => item.status)
    .filter((item) => !item.hidden)
    .lastIndexOf("success");

  if (lastSuccessFulStep >= 0) return steps[lastSuccessFulStep + 1];
  else return steps[0];
};

// Check if the given field in the formik form is a valid decimal number.
export const isDecimalWarning = (formik, field) => {
  const regex = /^\d+(\.\d{1,4})?$/;
  return (
    formik?.touched?.[field] &&
    !formik?.errors?.[field] &&
    formik?.dirty &&
    !regex.test(formik?.values?.[field]?.toString())
  );
};

// Convert HTML content to plain text, excluding table tags.
export const convertHtmlToText = ({ htmlContent }) => {
  if (htmlContent) {
    var div = document.createElement("div");
    div.innerHTML = htmlContent;

    // Remove tables tag
    var table = div.querySelector("table");
    if (table) {
      while (table?.firstChild) {
        table.removeChild(table?.firstChild);
      }
    }

    var textContent = div.textContent || div.innerText;
    div.remove();
    return textContent;
  } else return "";
};

// Asynchronously wait for a specified time.
export const asyncTimeout = (value) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, value);
  });
};

// Custom base query function with error handling for authentication errors.
export const customBaseQuery = async (args, api, extraOptions) => {
  const result = await fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,

    prepareHeaders: (headers) => {
      if (accessToken()) {
        headers.set("Authorization", `Bearer ${accessToken()}`);
      }
      return headers;
    },
    timeout: 5 * 60 * 1000,
  })(args, api, extraOptions);

  if (result.error?.status === 401 && accessToken()) {
    const data = result?.error?.data;
    const isExpired =
      data?.code === "TOKEN_EXPIRED" ||
      data?.message === "Token expired. Please sign in again.";

    if (isExpired) {
      // Clear all auth data and redirect immediately — no popup.
      [
        "token",
        "role",
        "auth_provider",
        "public_address",
        "signupPopupShown",
        "wallet_data",
        "isSignMessageShowed",
      ].forEach((key) => localStorage.removeItem(key));
      api.dispatch(setIsLoggedIn(false));
      window.location.href = "/";
    } else if (data?.message === "Invalid token!") {
      api.dispatch(generalSlice.actions.setShowExpireSessionPopup(true));
    }
  }

  return result;
};
